<template>
  <li
    v-on:click="toggle"
    v-bind:class="{ active: isActive, inactive: isInactive }"
    v-wave="{color: '#54a324',initialOpacity: 0.3,easing: 'ease-in'}"
  >
    {{ name }}
  </li>
</template>

<script>
import { Flow } from "../services/flow";

export default {
  name: "ConfiguratorStepPurposeItem",
  props: ["option", "item"],
  data: function() {
    return {};
  },
  computed: {
    name: function() {
      return this.item.name;
    },
    isActive: function() {
      if (this.$store.state.selected[this.option] !== null) {
        return (
          this.$store.state.selected[this.option].indexOf(this.item.id) >= 0
        );
      } else if (this.item.checked) {
        return this.item.checked;
      } else {
        return false;
      }
    },
    isInactive: function() {
      return this.$store.state.step != this.option;
    }
  },
  methods: {
    toggle: function() {
      this.$store.commit("toggleSingleOption", {
        name: this.option,
        value: this.item.id
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/assets/vars";

li {
  // margin: 0 5px;
  line-height: 20px;
  cursor: pointer;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  font-size: 16px;
  padding: 10px 5px 10px 20px;
}

li:hover {
  background: #eee;
}

li.inactive {
  color: #888;
}

li.active {
  color: #54a324;
}

li.active:after {
  content: "\E5CA";
  font-family: "Material Icons";
  font-size: 14px;
  line-height: 32px;
  position: absolute;
  left: 5px;
  top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/ConfiguratorStepPurposeItem.vue